export default function validateHex(value) {
  return /\b[0-9A-Fa-f]+\b/i.test(value);
}
